import { render, staticRenderFns } from "./outOfStockAlert.vue?vue&type=template&id=29d8d3be&scoped=true&"
import script from "./outOfStockAlert.vue?vue&type=script&lang=js&"
export * from "./outOfStockAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d8d3be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
